module.exports = __webpack_public_path__ + "static/media/icon-character__angela-merkel-hover.2530f7f2.svg";